// extracted by mini-css-extract-plugin
export default {"textWrapper":"Rules_textWrapper__bqgC-","title":"Rules_title__lQibZ","title_number":"Rules_title_number__NtgS3","text":"Rules_text__3Lgw+"};